// extracted by mini-css-extract-plugin
export default {"colors":"colors_colors__4-SUs","color":"colors_color__hP0FT","status":"colors_status__NkaNS"};